import ENVIRONMENT_VARIABLES from './environmentVariables';
var application = ENVIRONMENT_VARIABLES.APPLICATION_TARGET;
export var isTi = application === 'ti';
export var isHri = application === 'hri';
export var isSga = application === 'sga';
export var isStar = application === 'star';
export var isAdmiral = application === 'admiral';
export var isAdmes = application === 'admes';
export var isMillelacs = application === 'millelacs';